module.exports = __webpack_public_path__ + "img/DifficultyFire.5e267c32.png";